
import React, { useRef, useEffect, useState } from 'react';

const Clients: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const clients = [
    {
      name: "Cisco",
      logo: "/lovable-uploads/a49ba183-356f-4488-82b1-35d6eb2071af.png",
    },
    {
      name: "York University",
      logo: "/lovable-uploads/c8c979c7-a384-4e62-a807-cab83afcbbc1.png",
    },
    {
      name: "Habitat for Humanity Canada",
      logo: "/lovable-uploads/4debc272-1e4c-4c48-b265-355b18470137.png",
    },
    {
      name: "IdeaTheorem",
      logo: "/lovable-uploads/a46324d1-bdd9-4d94-8169-5e773aa8d825.png",
    },
    {
      name: "LogiSense",
      logo: "/lovable-uploads/9e4789d1-233d-48a3-82c0-70b4fc7c0729.png",
    },
    {
      name: "Save the Children Canada",
      logo: "/lovable-uploads/b82add1b-0367-4652-b103-5038fbc93b4f.png",
      customHeight: "55px", // Set a custom height for this specific logo
    },
  ];

  return (
    <section id="clients" className="py-12 bg-presintention-dark text-white section-padding" ref={sectionRef}>
      <div className="container-width max-w-5xl">
        <div className="text-center mb-10">
          <span className={`inline-block px-3 py-1 bg-presintention-accent/20 text-presintention-accent rounded-full text-sm font-medium mb-3 transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            Our Clients
          </span>
          <h2 className={`text-2xl md:text-3xl font-bold mb-4 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
            Trusted by <span className="text-presintention-accent">Leading Organizations</span>
          </h2>
          <p className={`max-w-2xl mx-auto text-white/70 text-base transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0 translate-y-4'}`}>
            We've helped professionals from these organizations transform their presentation skills.
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-6 gap-4 mt-8">
          {clients.map((client, index) => (
            <div 
              key={index} 
              className={`bg-white rounded-lg transition-all duration-500 hover:bg-gray-50 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
              style={{ transitionDelay: `${index * 50}ms` }}
            >
              <div className="flex flex-col items-center justify-center h-full p-4">
                <div className="h-12 w-full flex items-center justify-center mb-3">
                  <img 
                    src={client.logo} 
                    alt={client.name} 
                    className="h-full w-auto object-contain max-w-[80%]"
                    style={{ maxHeight: client.customHeight || "40px" }}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = "https://cdn-icons-png.flaticon.com/512/3442/3442315.png";
                    }}
                  />
                </div>
                <h4 className="text-sm font-medium text-center text-presintention-dark">{client.name}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
